import type { MockState } from './aiSkills';

/**
 * Заставка мока: что сказать ученику о состоянии и можно ли нажать «Начать» (20.10.2026, T5).
 *
 * ⚠️ СБОЙ ЗАПРОСА — НЕ «НЕ НАЗНАЧЕН». Не дошедший до сервера `GET /ielts/ai-skills` даёт в
 * хранилище «всё закрыто» с пометкой `failed`. Раньше заставка читала это как «Mock test
 * ещё не назначен» и блокировала кнопку — ученик видел ложь и не мог начать открытый мок
 * (стенд 20.10: свежая учётка, запрос оборвался в браузере). При сбое — честное «не
 * удалось проверить» с повтором, а «Начать» доступна: окно проверит сервер (423 с текстом).
 */
export type MockGate = {
  /** Какой текст состояния показать. */
  status: 'failed' | 'not_scheduled' | 'normal';
  /** Кнопка «Начать» неактивна. */
  startDisabled: boolean;
  /** Показать «Повторить проверку». */
  retry: boolean;
};

export function mockGate(mockState: MockState, failed: boolean): MockGate {
  if (failed) return { status: 'failed', startDisabled: false, retry: true };
  if (mockState === 'not_scheduled') return { status: 'not_scheduled', startDisabled: true, retry: false };
  return { status: 'normal', startDisabled: false, retry: false };
}
